import type { ScreenModule } from "../../../app/screen-module";
import { UserSettingsPage } from "../SettingsPages";

export default {
	id: "end-user.settings",
	path: "/app/settings",
	area: "end-user",
	navGroup: "自分の設定",
	label: "設定",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: UserSettingsPage,
} satisfies ScreenModule;
